// src/modules/app-views/offers/pages/Document/tabs/RecordTab/OfferFunnelCard.jsx
// *******************************************************************************
// OFFER FUNNEL CARD
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Col, Row, Tooltip } from 'antd';
import translateX from 'utils/translateX';
import SimpleCurrency from 'components/SimpleComponents/SimpleCurrency';
import SimpleSegment from 'components/SimpleComponents/SimpleSegment';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const SPARK_CURRENCY = [{ value: 'SPARK', label: 'SparkCoins', text: 'SparkCoins' }];

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const OfferLeadsDistributionCard = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  // Distribution options built inside component so translateX runs within i18n context
  const distributionOptions = [
    {
      value: 'supervised',
      label: (
        <Tooltip title={translateX('manager_distributes_leads')}>
          <span style={{ display: 'block', width: '100%' }}>
            {translateX('supervised')}
          </span>
        </Tooltip>
      ),
    },
    {
      value: 'marketplace',
      label: (
        <Tooltip title={translateX('agents_buy_with_sparks')}>
          <span style={{ display: 'block', width: '100%' }}>
            {translateX('marketplace')}
          </span>
        </Tooltip>
      ),
    },
    {
      value: 'automatic',
      label: (
        <Tooltip title={translateX('distributed_automatically')}>
          <span style={{ display: 'block', width: '100%' }}>
            {translateX('automatic')}
          </span>
        </Tooltip>
      ),
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Card title={translateX('lead_distribution')} style={{ marginTop: 16 }}>
      <Row gutter={[16, 0]} align="bottom">
        <Col xs={24} md={8}>
          <SimpleCurrency
            name="sparkCoinsCost"
            label="lead_price_sparks"
            currencies={SPARK_CURRENCY}
            showCurrencySelect={true}
            min={0}
            decimalPlaces={2}
          />
        </Col>

        <Col xs={24} md={16}>
          <SimpleSegment
            name="distributionMode"
            label="distribution_mode"
            options={distributionOptions}
            block
          />
        </Col>
      </Row>
    </Card>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OfferLeadsDistributionCard;
